<template>
  <div class="mb-20">
    <ChooseCategoryBlock
      v-bind="chooseCategoryBlockProps"
    />
  </div>
</template>

<script>
import ChooseCategoryBlock from '@/components/ChooseCategoryBlock'
import { serializeParameters } from '@/utils/general'
import { WebsiteCategories, WebsiteCategoryCookie } from '@/enums/app'
import { WomenCountries } from '@/enums/general'
import { SET_FORM_FIELD, SET_WOMEN_FORM_FIELD } from '@/utils/store/mutationTypes'
import { mapMutations } from 'vuex'

export default {
  name: 'Signup',
  layout: 'minimal',
  components: { ChooseCategoryBlock },
  middleware: ({ app, route, redirect, store: { state: { app: { locale, country } } } }) => {
    const category = app.$cookies.get(WebsiteCategoryCookie)
    const i18Params = `/${locale}-${country}`
    const queryParamsString = serializeParameters(route.query)

    if (WomenCountries.includes(country)) {
      if (category) {
        if (WebsiteCategories.men === category) {
          return redirect(`${i18Params}/${category}/signup?${queryParamsString}`)
        }

        return redirect(`${i18Params}/${category}/signup?${queryParamsString}`)
      }
    } else {
      return redirect(`${i18Params}/men/signup?${queryParamsString}`)
    }
  },
  computed: {
    chooseCategoryBlockProps () {
      return {
        image: '/images/frontend/static/mix-signup',
        womenLink: '/women/signup',
        menLink: '/men/signup',
        title: this.$t('ChooseCategoryPage.ChooseCategory'),
        description: this.$t('ChooseCategoryPage.ChooseCategoryDescription'),
        menAriaLabel: this.$t('Accessibilty.AriaLabels.GoToMenSignup'),
        womenAriaLabel: this.$t('Accessibilty.AriaLabels.GoToWomenSignup')
      }
    }
  },
  methods: {
    ...mapMutations('signup', {
      setMenFormField: SET_FORM_FIELD
    }),
    ...mapMutations('womenSignup', {
      setWomanFormField: SET_WOMEN_FORM_FIELD
    })
  }
}
</script>
